module.exports = __webpack_public_path__ + "c704cd755acc54f714d444023f7fbc42.svg";